import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import api from "../../api";
import { ICatalog, ICatalogType, IState } from "../../types";


export const login = createAsyncThunk(
    "login",
    async (data: any, thunkAPI) => {
        try {
            const response = await api.userLogin(data);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);

export const registration = createAsyncThunk(
    "registration",
    async (data: any, thunkAPI) => {
        try {
            const response = await api.userRegistration(data);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);


export const searchProduct = createAsyncThunk(
    "searchProduct",
    async (vin: string, thunkAPI) => {
        try {
            const response = await api.searchProduct(vin);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);

export const getCars = createAsyncThunk(
    "getCars",
    async (__, thunkAPI) => {
        try {
            const response = await api.getCars();
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);

export const getModel = createAsyncThunk(
    "getModel",
    async (id, thunkAPI) => {
        try {
            const response = await api.getModel(id);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);

export const getGenerations = createAsyncThunk(
    "getGenerations",
    async (id, thunkAPI) => {
        try {
            const response = await api.getGenerations(id);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);
export const getEngine = createAsyncThunk(
    "getEngine",
    async (id, thunkAPI) => {
        try {
            const response = await api.getEngine(id);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);
export const getEngines = createAsyncThunk('getEngines', async (__, thunkAPI) => {
    try {
        const data = await api.getCarEngines();
        return data;
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response);
    }
})
export const getBodies = createAsyncThunk(
    "getBodies",
    async (id, thunkAPI) => {
        try {
            const response = await api.getBodies(id);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);
export const getCarDetail = createAsyncThunk(
    "getCarDetail",
    async (id, thunkAPI) => {
        try {
            const response = await api.getCarDetail(id);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);
export const getCar = createAsyncThunk(
    "getCar",
    async (id, thunkAPI) => {
        try {
            const response = await api.getCar(id);
            return response;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response);
        }
    }
);
export const getCatalogs = createAsyncThunk('getCatalogs', async (__, thunkAPI) => {
    try {
        const response = await api.getAllCatalogs()
        return response
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
export const getHits = createAsyncThunk('getHits', async (__, thunkAPI) => {
    try {
        const res = await api.getAllHits()
        return res.response === "Empty" ? [] : res
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
export const deleteCatalog = createAsyncThunk("deleteCatalog", async (id: number, thunkAPI) => {
    try {
        const res = await api.deleteCatalog(id)
        return { res, id }
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
export const addNewDetail = createAsyncThunk('addNewDetail', async ({ engineId, newDetail }: any, thunkAPI) => {
    try {
        const res = await api.addNewDetail(engineId, newDetail)
        return engineId
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
export const addNewCatalog = createAsyncThunk('addNewCatalog', async (catalog: any, thunkAPI) => {
    try {
        const res = await api.addCatalog(catalog)
        return res
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
export const getAllCatalogTypes = createAsyncThunk('getAllCatalogTypes', async (_, thunkAPI) => {
    try {
        const res = await api.allCatalogTypes()
        return res
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
export const addNewCatalogType = createAsyncThunk('addNewCatalogType', async (catalogType: string, thunkAPI) => {
    try {
        const res = await api.addCatalogType(catalogType)
        return res
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
export const deleteCatalogType = createAsyncThunk('deleteCatalogType', async (catalogType: string, thunkAPI) => {
    try {
        const res = await api.deleteCatalogType(catalogType)
        return { res, catalogType }
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
export const getCatalogsByType = createAsyncThunk("getCatalogsByType", async (catalogType: string, thunkAPI) => {
    try {
        const res = await api.getCatalogType(catalogType)
        return res
    } catch (e: any) {
        return thunkAPI.rejectWithValue(e.response)
    }
})
const initialState: IState = {
    catalogTypes: {
        allCatalogTypes: [],
        loader: false,
        error: false
    },
    isAuth: false,
    searchProducts: {},
    adminSidebar: false,
    registrationModal: false,
    loginModal: false,
    loading: true,
    catalogs: [],
    cars: [],
    car: {},
    models: [],
    bodies: [],
    generations: [],
    engine: [],
    carAdmin: [],
    modelsAdmin: [],
    bodiesAdmin: [],
    generationsAdmin: [],
    engineAdmin: [],
    basket: [],
    details: [],
    hits: [],
    filtredCatalog: {
        catalogs: {
            catalogName: "", catalogs: [], catalogTypeId: 0
        },
        error: false,
        loader: true
    },
    user: {},
    adding: {
        addingNotification: true,
        addingLoader: false
    }
};

const productSlice = createSlice({
    name: "productSlice",
    initialState,
    reducers: {
        setAdminSidebar: (state) => {
            state.adminSidebar = !state.adminSidebar;
        },
        setIsAuth: (state, action) => {
            state.isAuth = action.payload
        },
        logout: (state, action) => {
            state.isAuth = false
            localStorage.removeItem("token")
        },
        setRegistrationModal: (state) => {
            state.registrationModal = !state.registrationModal
        }, setLoginModal: (state) => {
            state.loginModal = !state.loginModal
        }, setCart: (state, action) => {
            state.basket = [...action.payload]
        },
        addToCart: (state, action) => {
            state.basket = [...state.basket, action.payload]
        },
        removeFromCart: (state, action) => {
            state.basket = state.basket.filter(el => el.id != action.payload)
        },
        incrementBasketAmount: (state, action) => {
            state.basket = state.basket.map(el =>
                el.id == action.payload
                    ? (el = {
                        ...el,
                        amount: el.amount + 1,
                    })
                    : { ...el })
        }, decrementBasketAmount: (state, action) => {
            state.basket = state.basket.map(el =>
                el.id == action.payload
                    ? (el = {
                        ...el,
                        amount: el.amount - 1,
                    })
                    : { ...el })
        },
        setAmount: (state, action) => {
            state.basket = state.basket.map(el =>
                el.id == action.payload.id
                    ? (el = {
                        ...el,
                        amount: action.payload.newAmount,
                    })
                    : { ...el })
        }

    },
    extraReducers: (builder) => {
        builder.addCase(getCars.fulfilled, (state, action: PayloadAction<any>) => {
            state.cars = action.payload;
            let myArr: any = []
            action.payload.map((el: any) => {
                myArr.push({
                    id: el.carId,
                    name: el.carName
                })
            })
            state.carAdmin = myArr;
            state.loading = false
        })
        builder.addCase(getCar.fulfilled, (state, action: PayloadAction<any>) => {
            state.models = action.payload;
            let myArr: any = []
            action.payload.map((el: any) => {
                myArr.push({
                    id: el.carModelId,
                    name: el.carModelName
                })
            })
            state.modelsAdmin = myArr;
            state.loading = false
        })
        builder.addCase(getCarDetail.fulfilled, (state, action: PayloadAction<any>) => {
            state.details = action.payload;
            state.loading = false
        })
        builder.addCase(getGenerations.fulfilled, (state, action: PayloadAction<any>) => {
            state.bodies = action.payload;
            let myArr: any = []
            action.payload.map((el: any) => {
                myArr.push({
                    id: el.bodyId,
                    name: el.bodyName
                })
            })
            state.bodiesAdmin = myArr;
            state.loading = false
        })
        builder.addCase(getModel.fulfilled, (state, action: PayloadAction<any>) => {
            state.generations = action.payload;
            let myArr: any = []
            action.payload.map((el: any) => {
                myArr.push({
                    id: el.generationId,
                    name: el.generationName
                })
            })
            state.generationsAdmin = myArr;
            state.loading = false
        })
        builder.addCase(getBodies.fulfilled, (state, action: PayloadAction<any>) => {
            state.bodies = action.payload;
            let myArr: any = []
            action.payload.map((el: any) => {
                myArr.push({
                    id: el.bodyId,
                    name: el.bodyName
                })
            })
            state.bodiesAdmin = myArr;
            state.loading = false
        })
        builder.addCase(getEngine.fulfilled, (state, action: PayloadAction<any>) => {
            state.engine = action.payload;
            let myArr: any = []
            action.payload.map((el: any) => {
                myArr.push({
                    id: el.engineId,
                    name: el.engineName
                })
            })
            state.engineAdmin = myArr;
            state.loading = false
        })
        builder.addCase(login.fulfilled, (state, action: PayloadAction<any>) => {
            state.user = action.payload;
            state.loginModal = false
            state.isAuth = true
            localStorage.setItem("token", action.payload?.token)
        })
        builder.addCase(login.rejected, (state, action: PayloadAction<any>) => {
            alert("ошибка")
        })
        builder.addCase(registration.fulfilled, (state, action: PayloadAction<any>) => {
            state.loginModal = true
            state.registrationModal = false
        })
        builder.addCase(registration.rejected, (state, action: PayloadAction<any>) => {
            alert("ошибка")
        })

        builder.addCase(getCar.pending, (state, action: PayloadAction<any>) => {
            state.loading = true
        })
        builder.addCase(getCarDetail.pending, (state, action: PayloadAction<any>) => {
            state.loading = true
        })
        builder.addCase(getGenerations.pending, (state, action: PayloadAction<any>) => {
            state.loading = true
        })
        builder.addCase(getModel.pending, (state, action: PayloadAction<any>) => {
            state.loading = true
        })
        builder.addCase(getBodies.pending, (state, action: PayloadAction<any>) => {
            state.loading = true
        })
        builder.addCase(getEngine.pending, (state, action: PayloadAction<any>) => {
            state.loading = true
        })
        builder.addCase(getEngines.fulfilled, (state, action) => {
            state.engine = action.payload
        })
        builder.addCase(searchProduct.fulfilled, (state, action: PayloadAction<any>) => {
            state.searchProducts = action.payload;
        })
        builder.addCase(getCatalogs.fulfilled, (state, action) => {
            state.catalogs = action.payload
        })
        builder.addCase(getHits.pending, (state, action) => {
            // state.loading = true
        })
        builder.addCase(getHits.fulfilled, (state, action) => {
            state.loading = false
            state.hits = action.payload
        })
       
        builder.addCase(addNewCatalog.fulfilled, (state, action) => {
            state.adding.addingNotification = true
            state.adding.addingLoader = false
        }).addCase(addNewCatalog.rejected, (state, action) => {
            state.adding.addingNotification = false
            state.adding.addingLoader = false
        }).addCase(addNewCatalog.pending, (state) => {
            state.adding.addingLoader = true
        })
        builder.addCase(getAllCatalogTypes.fulfilled, (state, action) => {
            state.catalogTypes.allCatalogTypes = action.payload
            state.catalogTypes.loader = false
        }).addCase(getAllCatalogTypes.rejected, (state, action) => {
            state.catalogTypes.error = true
            state.catalogTypes.loader = false
        }).addCase(getAllCatalogTypes.pending, (state) => {
            state.catalogTypes.loader = true
        })
        builder.addCase(addNewCatalogType.pending, (state, action) => {
            state.catalogTypes.loader = true
        }).addCase(addNewCatalogType.rejected, (state) => {
            state.catalogTypes.error = true
            state.catalogTypes.loader = false
        }).addCase(addNewCatalogType.fulfilled, (state, action) => {
            state.catalogTypes.loader = false
            state.catalogTypes.allCatalogTypes = [...state.catalogTypes.allCatalogTypes, action.payload]
        })
        builder.addCase(deleteCatalogType.pending, (state) => {
            state.catalogTypes.loader = true
        }).addCase(deleteCatalogType.rejected, (state) => {
            state.catalogTypes.error = true
            state.catalogTypes.loader = false
        }).addCase(deleteCatalogType.fulfilled, (state, action) => {
            state.catalogTypes.loader = false
            state.catalogTypes.allCatalogTypes = state.catalogTypes.allCatalogTypes.filter(e => e.catalogName != action.payload.catalogType)
        })
        builder.addCase(getCatalogsByType.pending, (state) => {
            state.filtredCatalog.loader = true
        }).addCase(getCatalogsByType.rejected, (state) => {
            state.filtredCatalog.loader = false
            state.filtredCatalog.error = true
        }).addCase(getCatalogsByType.fulfilled, (state, action) => {
            state.filtredCatalog.loader = false
            state.filtredCatalog.catalogs = action.payload
        })
        builder.addCase(deleteCatalog.fulfilled, (state, action) => {
            state.filtredCatalog.catalogs.catalogs = state.filtredCatalog.catalogs.catalogs.filter(e => e.catalogId != action.payload.id)
        })

    }
});


export const {
    logout,
    setAdminSidebar,
    setIsAuth,
    setRegistrationModal,
    setLoginModal,
    incrementBasketAmount,
    decrementBasketAmount,
    addToCart,
    removeFromCart,
    setCart,
    setAmount
} = productSlice.actions;

export default productSlice.reducer;
